import React from 'react';
import '../styles/Home.css';
import { ReactComponent as MyIconito } from '../factory-male.svg';
import { ReactComponent as MyIconito2 } from '../fast-food.svg';

const Hero = () => {
    return (
        <section className='hero-section'>
            <div className='hero-deco-left float-icons'>
                <MyIconito width={140} height={180} />
            </div>
            <div className='hero-deco-right float-icons'>
                <MyIconito2 width={140} height={180} />
            </div>

            <div className='hero-content'>
                <div className='hero-text'>
                    <span className='hero-eyebrow'>Free · Android</span>
                    <h1 className='hero-headline'>
                        Your business,<br />
                        <span className='brand-text'>online in minutes.</span>
                    </h1>
                    <p className='hero-subtext'>
                        Menu & Catalog Maker helps any business build a beautiful digital presence — menus, catalogs, offers, and portfolios, all in one place.
                    </p>

                    <div className='hero-downloads'>
                        <div
                            className='hero-cta-wrap'
                            onClick={() => window.open('https://play.google.com/store/apps/details?id=com.aguslc.monbusiness', '_blank')}
                        >
                            <button className='button cta-button'>Download on Play Store</button>
                            <span className='hero-cta-note'>Free · Android</span>
                        </div>
                    </div>
                </div>

                <div className='hero-image-wrap'>
                    <img src='/monbusiness-logo.jpeg' alt='Menu & Catalog Maker app' className='hero-image' />
                </div>
            </div>
        </section>
    );
};

export default Hero;
